export default __webpack_public_path__ + "static/media/arrow-up.ffb3f07c.svg";